
/*
Input

track object

{
  track: {
    data: { sample: val },
    clinical: bool,
    clinicalData: {
      group: str
      numerical: bool
      show: bool,
      trackDetails: [
        { 
          color: str
          label: str || num
          show: bool
          value: num
        }
      ]
    }
    ...
  }
}
*/

import localTrackDetails from "../refs/newTrackDetails"
import trackDetails from "../refs/trackDetails";

/*
Output

Plotly trace group object (group of tracks)

{
    x: [...samples],
    y: [track],
    z: [...colorKeys],
    type: 'heatmap',
    colorscale,
    zmin,
    zmax,
    showscale: false,
    connectgaps: false,
    hoverongaps: true,
    autocolorscale: false,
}
 */

export default function generateCategoricalTrack(
  {
    sampleOrder,
    track
  }) 
  {
    let labelValue = {}
    let labelColor = {}

    console.log("trying to generate categorical tracks");
    // console.log(track.clinicalData);
    // console.log(track);
    // console.log(track.title);
    console.log(track.title);
    console.log(localTrackDetails[ track.title ]);

    track.clinicalData.trackDetails.forEach((trackEntry) => {
      if (trackEntry.value) {
        labelValue[trackEntry.label] = trackEntry.value
        labelColor[trackEntry.label] = trackEntry.color
      }
    })


    // track.data.forEach((trackEntry) => {
    //   if (trackEntry.value) {
    //     labelValue[trackEntry.label] = trackEntry.value
    //     labelColor[trackEntry.label] = trackEntry.color
    //   }
    // })

      console.log(labelValue);
      console.log(labelValue);

    const z = sampleOrder.map(sample => 
      labelValue[track.data[sample]]
    )

    console.log( "printing sampleOrder values" );
    console.log(z);

    return {
      x: [...sampleOrder],
      y: [ track.title ],
      z: [z],
      type: 'heatmap',
      connectgaps: false,
      hoverongaps: true,
      autocolorscale: false,
      // hovertemplate: `%{y}: %{z}<extra></extra>`,
      showscale: false,
      colorscale: Object
        .values(labelColor)
        .map((color, i) => {
            const opts = Object.keys(labelColor).length - 1
            return [i/opts, color]
        }),
      zmax: Math.max(...Object.values(labelValue)),
      zmin: Math.min(...Object.values(labelValue)),
    }
}
